<template>
  <div>
    <div class="custom-evaluate">
      <div class="evaluate-wrap">
        <evaluateItem  v-for="item in evaluateData" :key="item.key" :evaluateData="item"/>
      </div>
    </div>
  </div>
</template>
<script>
import evaluateItem from './evaluateItem.vue'

export default {
  components: {
    evaluateItem,
  },
  props: {

  },
  data() {
    return {
      evaluateData: [
        {
          key: Math.random(),
          title: '京东服务+【商家服务】',
          department: '技术与数据智能部-供应链技术部',
          user: '长信保险经纪（北京）有限公司',
          remark: ' 文档与现行系统差异过大，包括但不限于（对接方案SDK），对接文档相关字段的必填项目未描述清楚等。 ',
          start: 2,
          timeline: '2023/12/19'
        },
        {
          key: Math.random(),
          title: '京东快递快运',
          department: '技术与数据智能部-快递快运技术部',
          user: '企企赢科技有限公司',
          remark: ' 对接的人只知道让看文档 ',
          start: 1,
          timeline: '2023/12/01'
        },
        {
          key: Math.random(),
          title: '大件纯配',
          department: '技术与数据智能部-供应链技术部',
          user: '赣州市南康区尔宇木家具有限公司',
          remark: ' 文档和实际放回数据有差异 ',
          start: 3,
          timeline: '2023/11/21'
        },
        {
          key: Math.random(),
          title: '京东快递快运',
          department: '技术与数据智能部-快递快运技术部',
          user: '杭州启实科技有限公司',
          remark: ' 文档有的字段和返回值对不上，并且为什么测试环境也会真的发货 ',
          start: 3,
          timeline: '2023/10/12'
        },
        {
          key: Math.random(),
          title: '京东快递快运',
          department: '技术与数据智能部-快递快运技术部',
          user: '北京喜舒科技有限公司',
          remark: ' 部分业务文档不全 ',
          start: 3,
          timeline: '2023/07/01'
        },
        {
          key: Math.random(),
          title: '京东快递快运',
          department: '技术与数据智能部-快递快运技术部',
          user: '北京喜舒科技有限公司',
          remark: ' 工单处理速度慢 ',
          start: 1,
          timeline: '2023/07/01'
        },
      ]
    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.custom-evaluate {
  width: 590px;
  height: 362px;
  background-color: #fff;
  .evaluate-wrap {
    height: 100%;
    padding-right: 12px;
    overflow-y: scroll;

        /* 隐藏默认滚动条 */
    &::-webkit-scrollbar {
      width: 0.5em;
    }

    /* 定义滚动条轨道样式 */
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    /* 定义滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      background-color: #E4E5E9;
      border-radius: 4px;
    }

    /* 定义滚动条滑块悬停样式 */
    &::-webkit-scrollbar-thumb:hover {
      background-color: #c0c1c7;
    }
  }
}
</style>
